import { render, staticRenderFns } from "./SessionChat.vue?vue&type=template&id=16655440"
import script from "./SessionChat.vue?vue&type=script&lang=js"
export * from "./SessionChat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports